export let isBooking = false;
export const setCanBooking = () => {
  isBooking = true;
};
